import * as React from 'react';
const CustomDnbStatus = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
    <defs>
      <style>
        {'.custom_dnb_status_svg__cls-1{fill:none;stroke:#b3b3b3;stroke-linecap:round;stroke-linejoin:round}'}
      </style>
    </defs>
    <g id="custom_dnb_status_svg__Layer_2" data-name="Layer 2">
      <g id="custom_dnb_status_svg__Layer_1-2" data-name="Layer 1">
        <path d="M18 35.5A17.5 17.5 0 1 0 .5 18 17.49 17.49 0 0 0 18 35.5" className="custom_dnb_status_svg__cls-1" />
        <path
          d="M3.54 20.28h3.62c3.35 0 3.06-2.84 5.52-14.65a.75.75 0 0 1 .32-.44.76.76 0 0 1 .43-.19.78.78 0 0 1 .48.17.7.7 0 0 1 .26.44l4.66 22.72a.8.8 0 0 0 .26.43.76.76 0 0 0 1 0 .82.82 0 0 0 .27-.43L23.53 15a.7.7 0 0 1 .25-.4.7.7 0 0 1 .43-.18.8.8 0 0 1 .46.11.8.8 0 0 1 .31.37c1.13 2.82 1.58 5.38 4.21 5.38h3.27"
          className="custom_dnb_status_svg__cls-1"
        />
      </g>
    </g>
  </svg>
);
export default CustomDnbStatus;
